import photo1 from "../../../assets/images/appImages/member-1.png"
import photo2 from "../../../assets/images/appImages/member-2.png"
import photo3 from "../../../assets/images/appImages/member-3.png"
import photo4 from "../../../assets/images/appImages/member-4.png"

export const TeamData = [
  {
    id: 1,
    photo: photo1,
    name: "Marie Guignane FAYE",
    role: "Fondatrice membre honoraire",
  },
  {
    id: 3,
    photo: photo2,
    name: "Sylvie Jacqueline KANE",
    role: "Coordinatrice Générale et Directrice",
  },
  {
    id: 3,
    photo: photo3,
    name: "Sophie DIOP",
    role: "Conseillère en Design",
  },
  {
    id: 4,
    photo: photo4,
    name: "Ndéye Oulimata MBAYE",
    role: " Assistante Administrative et Opérationnelle",
  },

]
